export default "__VITE_ASSET__y6pFgQ0___"